import { SESSION_STATUS } from '@/constants/auth';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import useAnonymousSearchLimitStore, {
  MAX_UNAUTH_SEARCHES,
} from '@/publicSearch/store/useAnonymousSearchLimitStore';
import useRateLimitStore from '@/publicSearch/store/useRateLimitStore';

const usePublicSearchLimit = () => {
  const { status } = useSession();
  const isAuthenticated = status === SESSION_STATUS.AUTHENTICATED;
  const isServerRateLimited = useRateLimitStore((s) => s.isRateLimited);
  const count = useAnonymousSearchLimitStore((s) => s.count);
  const isClientLimited = useAnonymousSearchLimitStore((s) => s.isLimited);
  const setAuthenticated = useAnonymousSearchLimitStore(
    (s) => s.setAuthenticated,
  );
  const syncFromStorage = useAnonymousSearchLimitStore(
    (s) => s.syncFromStorage,
  );

  useEffect(() => {
    syncFromStorage();
  }, [syncFromStorage]);

  useEffect(() => {
    setAuthenticated(isAuthenticated);
  }, [isAuthenticated, setAuthenticated]);

  return {
    hasReachedSearchLimit:
      !isAuthenticated && (isServerRateLimited || isClientLimited),
    searchCount: count,
    maxSearches: MAX_UNAUTH_SEARCHES,
  };
};

export default usePublicSearchLimit;
